<template>
  <router-link to="/first-steps" v-if="!!(remainingSteps) && !(hideTutorial) && $route.name != 'first steps'">
    <div class="first-steps-overlay z-index">
      <span class="first-steps-overlay__text"> <vs-icon icon="done_all"/> Primeros pasos</span>
      <span class="first-steps-overlay__steps">{{ remainingSteps }}</span>
    </div>
  </router-link>
</template>

<script>
import gql from 'graphql-tag'
import axios from 'axios'
import { print } from 'graphql'
import { mapMutations, mapState } from 'vuex'

const fetchOnboardingStep = gql`
query fetchOnboardingStep($currentUserToken: String!, $steps: [String!]!) {
    fetchOnboardingStep(currentUserToken: $currentUserToken, steps: $steps) {
      name
      seen
    }
  }
`

export default {
  name: 'fixed-steps',
  data () {
    return {
      remainingSteps: 0,
      hideTutorial: Boolean,
    }
  },
  watch:{
    $route (to, from){
      this.fetchSteps()
    }
  } ,
  mounted () {
    this.fetchSteps()
  },
  computed: {
    ...mapState({
      currentUser: state => state.User.currentUser
    })
  },
  methods: {
    fetchSteps() {
      axios.get(`${process.env.VUE_APP_GRAPH_PATH}`, { params: {
        query: print(fetchOnboardingStep),
        variables: {
          currentUserToken: localStorage.getItem('USER_TOKEN'),
          steps: ['account', 'entity', 'market', 'offer', 'hideTutorial']
        }
      }}).then(res => {
        if (!res.data.errors) {
          this.remainingSteps = res.data.data.fetchOnboardingStep.filter(el => el.seen === false && el.name != 'hideTutorial').length
          this.hideTutorial = res.data.data.fetchOnboardingStep[4].seen
        }else{
          console.log(res.data.errors)
        }
      }).catch(err =>{
        console.log(err)
      })
    }
  }
}
</script>
<style scoped>
  .z-index{
    z-index: 300001;
  }
</style>